import { SvgIconComponent } from '@mui/icons-material';
import { Box, Button, ButtonProps, Tooltip } from '@mui/material';
import { FC } from 'react';

type TableActionButtonProps = ButtonProps & {
  title: string;
  Icon: SvgIconComponent;
};

export const TableActionButton: FC<TableActionButtonProps> = ({ Icon, title, ...buttonProps }) => {
  const { size, sx } = buttonProps;
  return (
    <Tooltip title={title}>
      <Box display="flex" alignItems="center">
        <Button
          {...buttonProps}
          sx={{ ...(sx !== undefined ? sx : {}), padding: '4px', minWidth: size === 'small' ? '32px' : '44px' }}
        >
          <Icon fontSize={size} />
        </Button>
      </Box>
    </Tooltip>
  );
};
